export default function ActivitySafeReturnIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='24px'
      height='24px'
      viewBox='0 0 24 24'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      {...props}>
      <g id='web' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='4---HHA-Pt-Story-Refused-State' transform='translate(-573.000000, -635.000000)'>
          <g id='Group-15' transform='translate(558.000000, 314.000000)'>
            <g id='Group-14' transform='translate(0.000000, 304.000000)'>
              <g id='Group-17' transform='translate(15.000000, 17.000000)'>
                <rect id='Rectangle-Copy-2' fill='#F3F3F4' x='0' y='0' width='24' height='24' rx='3' />
                <g
                  id='f-delete'
                  transform='translate(5.000000, 5.000000)'
                  fill='#0F1226'
                  fillOpacity='0.5'
                  fillRule='nonzero'>
                  <path d='M7.0 0a7.0 7.0 0 1 0 0 14.0A7.0 7.0 0 0 0 7.0 0Zm2.041 9.916a0.5840.584 0 0 1 0-1.1660.8750.875 0 0 0 0-1.75H5.834a0.1460.146 0 0 0-0.1460.146v1.022a0.4370.437 0 0 1-0.7480.308l-1.75-1.75a0.4380.438 0 0 1 0-0.619l1.75-1.75a0.4370.437 0 0 1 0.7480.309v1.022a0.1460.146 0 0 0 0.1460.146h3.207a2.041 2.041 0 1 1 0 4.082Z' />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
